import axios from 'axios';

import { addUnauthorizedInterceptor } from '@services/interceptors';

import { getCurrencyExchange } from './v2/get-currency-exchange';
import { getCoupons } from './admin/get-coupons';
import { getGateways } from './admin/get-gateways';
import { getCurrencies } from './admin/get-currencies';
import { searchCoupons } from './admin/search-coupons';
import { createGiftCard } from './admin/create-giftcard';

const BASE_URL = process.env.REACT_APP_PAYMENTS_URL as string;
const httpClient = axios.create({
    baseURL: BASE_URL,
});
addUnauthorizedInterceptor(httpClient);
const paymentsSDK = {
    admin: {
        gateways: {
            get: getGateways,
        },
        currencies: {
            get: getCurrencies,
        },
        coupons: {
            search: searchCoupons,
            get: getCoupons,
            createGiftCard,
        },
    },
    v2: {
        getCurrencyExchange,
    },
};

export { paymentsSDK, httpClient };
